import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';
import { useToast } from '../../../Hooks/useToast';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import { EliminarInformeConservacion } from '../Services/EliminarInformeConservacion';

const ModalEliminarInforme = (props) => {
	const {  datosModal, ...rest } = props;
	const [mensajeModal, setMensajeModal] = useState({ titulo: "", texto: "" });
	const addToast = useToast();
	const { usuario } = useLogin();

	const btnEliminarInforme = async () => {
		const values = {
			idUsuario: usuario.id,
			InformeConservacionId: datosModal.informeConservacionId
		}
		const resp = await EliminarInformeConservacion(values);
		if (resp) {
			if (resp.status === 200) {
				if (resp.data) {
					addToast({ mostrar: true, mensaje: "Se ha eliminado correctamente el  informe de " + datosModal.indicador.sigla + " - " + datosModal.exigencia.sigla + " del periodo " + datosModal.ano + (datosModal.trimestre? (" - " + datosModal.trimestre) : ("")), titulo: 'Confirmación', tipo: 'Success' });
				}
			}
		}
		rest.onHide();
	}
	useEffect(() => {
        if(datosModal){
            setMensajeModal({ titulo: "¿Está seguro que desea eliminar el informe de " + datosModal.indicador.sigla + " - " + datosModal.exigencia.sigla + " del periodo " + datosModal.ano + (datosModal.trimestre? (" - " + datosModal.trimestre) : ("")) + "?" });
        }
			
	}, [datosModal]);
	return (
		<Modal
			{...rest}
			size="md"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body>
				<div className='info my-4'>
					<span className='info__icon'>
						<i className='ico-user-delete'></i>
					</span>
					<h6 className='info__title'>{mensajeModal.titulo}</h6>
					<p className='info__text'>{mensajeModal.texto}</p>
				</div>
				<div className="d-flex flex-column flex-md-row justify-content-center align-items-stretch align-items-md-center gap-4">
					<Button type="button" design="btn-outline-pewter-blue btn--small" onClick={rest.onHide}>Cancelar</Button>
					<Button type="button" design="btn-primary btn--small" onClick={btnEliminarInforme}>Aceptar</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}
export default ModalEliminarInforme;
